import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "mobile-login"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "form"
};
var _hoisted_4 = {
  key: 0,
  class: "forget"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  key: 2
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  class: "tip"
};
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { computed, ref } from "vue";
import FormItem from "./form/FormItem.vue";
import MobileForgetPasswordPopup from "./ForgetPasswordStep1Popup.vue";
import MobileRegisterPopup from "./MobileRegisterPopup.vue";
import { isPhoneAccount } from "./helper";
import { afterLoginInit } from "@/utils/initUtil";
import { mobileLogin } from "@/api/user";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { getSupplyId, setToken, setUserId } from "@/utils/authUtil";
import { Notify } from "@/utils/notifyUtil";
import { INCORRECT_PASSEORD, INCORRECT_USERNAME } from "@/constant/responseCode";
import { Persistent } from "@/utils/cache/persistent";
import BaseCountDown from "@/components/base/baseCountDown.vue";
import { watch } from "vue";
import md5 from "js-md5";
import { useSupplierStore } from "@/store/supplierStore";
import { PopupPageKey } from "@/constant/pageKey";
import { useI18n } from "vue-i18n";
var retryKey = "cache_error_retry_count";
var timeKey = "cache_error_retry_time";
export default {
  __name: 'MoblieLoginPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:show", "success"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var emit = __emit;
    var props = __props;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    watch(showPopup, function (val) {
      if (val) {
        updateRemainingTime();
      }
    });
    var retryCount = ref(Persistent.getLocal(retryKey) || 0);
    var retryTime = ref(Persistent.getLocal(timeKey) || 0);
    var remainingTime = ref(0);
    var updateRemainingTime = function updateRemainingTime() {
      var banTime = 24 * 3600; // 24小时内禁止登录
      if (retryTime.value > 0) {
        var diff = (Date.now() - retryTime.value) / 1000;
        if (diff < banTime) {
          remainingTime.value = banTime - diff;
        } else {
          Persistent.removeLocal(timeKey);
          Persistent.removeLocal(retryKey);
        }
      }
      return 0;
    };
    var errorForm = ref({
      phone: ""
    });
    var formData = ref({
      calling_code: "",
      phone: "",
      password: ""
    });
    var onCountdownEnd = function onCountdownEnd() {
      Persistent.removeLocal(timeKey);
      Persistent.removeLocal(retryKey);
      remainingTime.value = 0;
      retryCount.value = 0;
      retryTime.value = 0;
    };
    var isDisabled = computed(function () {
      return !formData.value.calling_code || !formData.value.phone || !formData.value.password || remainingTime.value > 0;
    });
    var isShowForgetPopup = ref(false);
    var forget = function forget() {
      isShowForgetPopup.value = true;
    };
    var isShowRegisterPopup = ref(false);
    var register = function register() {
      isShowRegisterPopup.value = true;
    };
    var checkParams = function checkParams() {
      var flag = true;
      if (!isPhoneAccount(formData.value.phone, formData.value.calling_code)) {
        errorForm.value.phone = t("wrongFormatOfPhoneNumber");
        flag = false;
      }
      if (flag) {
        errorForm.value.phone = "";
      }
      return flag;
    };
    var login = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, now;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkParams()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              showLoading();
              _context.next = 5;
              return mobileLogin({
                supplier_id: getSupplyId(),
                area_code: formData.value.calling_code,
                phone: formData.value.phone,
                password: md5(formData.value.password)
              });
            case 5:
              res = _context.sent;
              if (!res.isOK) {
                _context.next = 21;
                break;
              }
              setToken(res.data.token);
              setUserId(res.data.data.associate_user_id);
              _context.next = 11;
              return afterLoginInit();
            case 11:
              hideLoading();
              formData.value.phone = "";
              formData.value.password = "";
              showPopup.value = false;
              emit("success");
              Persistent.removeLocal(retryKey);
              Persistent.removeLocal(timeKey);
              retryCount.value = 0;
              _context.next = 22;
              break;
            case 21:
              if (res.code === INCORRECT_PASSEORD || res.code === INCORRECT_USERNAME) {
                hideLoading();
                Notify.error(t("incorrectMobilePhoneNumberOrPassword"));
                retryCount.value += 1;
                formData.value.password = "";
                if (retryCount.value < 5) {
                  Persistent.setLocal(retryKey, retryCount.value);
                } else {
                  now = Date.now();
                  Persistent.setLocal(retryKey, retryCount.value);
                  Persistent.setLocal(timeKey, now);
                  retryTime.value = now;
                  updateRemainingTime();
                }
              } else {
                hideLoading();
              }
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function login() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onRegisterSuccess = function onRegisterSuccess(code, phone) {
      formData.value.calling_code = code;
      formData.value.phone = phone;
    };
    return function (_ctx, _cache) {
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[6] || (_cache[6] = function ($event) {
          return showPopup.value = $event;
        }),
        title: "",
        "content-class": "mobile-login-container",
        "page-key": _unref(PopupPageKey).MOBILE_LOGIN
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("login")), 1), _createElementVNode("form", _hoisted_3, [_createVNode(FormItem, {
            callcode: formData.value.calling_code,
            "onUpdate:callcode": _cache[0] || (_cache[0] = function ($event) {
              return formData.value.calling_code = $event;
            }),
            modelValue: formData.value.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return formData.value.phone = $event;
            }),
            label: _ctx.$t('phone'),
            type: "phone",
            error: errorForm.value.phone,
            clearable: "",
            onInput: _cache[2] || (_cache[2] = function ($event) {
              return errorForm.value.phone = '';
            })
          }, null, 8, ["callcode", "modelValue", "label", "error"]), _createVNode(_component_Gap, {
            h: 0.2
          }), _createVNode(FormItem, {
            modelValue: formData.value.password,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return formData.value.password = $event;
            }),
            clearable: "",
            label: _ctx.$t('password'),
            type: "password"
          }, null, 8, ["modelValue", "label"])]), _unref(supplierStore).getIsSMSOpen ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", {
            onClick: forget
          }, _toDisplayString(_ctx.$t("forgetPassword")), 1)])) : _createCommentVNode("", true), _createVNode(_component_Button, {
            class: "login-btn",
            disabled: isDisabled.value,
            onClick: login
          }, {
            default: _withCtx(function () {
              return [_createVNode(BaseCountDown, {
                time: remainingTime.value,
                onEnd: onCountdownEnd
              }, {
                default: _withCtx(function (scope) {
                  return [remainingTime.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, [scope.hh > '00' ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("tryAgainInNHoursNMinutes", [scope.hh, scope.mm])), 1)) : scope.mm > '00' ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("tryAgainInNMinutesNSeconds", [scope.mm, scope.ss])), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("tryAgainInNSeconds", [scope.ss])), 1))])) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("login")), 1))];
                }),
                _: 1
              }, 8, ["time"])];
            }),
            _: 1
          }, 8, ["disabled"]), _createElementVNode("div", _hoisted_10, [_createTextVNode(_toDisplayString(_ctx.$t("dontHaveAnAccount")) + " ", 1), _createElementVNode("span", {
            onClick: register
          }, _toDisplayString(_ctx.$t("register")), 1)])]), _createVNode(MobileForgetPasswordPopup, {
            show: isShowForgetPopup.value,
            "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
              return isShowForgetPopup.value = $event;
            }),
            phone: formData.value.phone
          }, null, 8, ["show", "phone"]), _createVNode(MobileRegisterPopup, {
            show: isShowRegisterPopup.value,
            "onUpdate:show": _cache[5] || (_cache[5] = function ($event) {
              return isShowRegisterPopup.value = $event;
            }),
            onSuccess: onRegisterSuccess
          }, null, 8, ["show"])];
        }),
        _: 1
      }, 8, ["show", "page-key"]);
    };
  }
};